import Button from '@codegouvfr/react-dsfr/Button';
import { cx } from '@codegouvfr/react-dsfr/fr/cx';
import Table from '@codegouvfr/react-dsfr/Table';
import clsx from 'clsx';
import type { AdminFieldConfig } from 'maestro-shared/schema/SpecificData/FieldConfigInput';
import { assert, type Equals } from 'tsafe';
import { FieldInputTypeLabels } from './fieldInputTypeLabels';

type Props = {
  fields: AdminFieldConfig[];
  readOnly: boolean;
  onAdd: () => void;
  onEdit: (field: AdminFieldConfig) => void;
  onDelete: (field: AdminFieldConfig) => void;
};

export const FieldsTable = ({
  fields,
  readOnly,
  onAdd,
  onEdit,
  onDelete,
  ..._rest
}: Props) => {
  assert<Equals<keyof typeof _rest, never>>();

  return (
    <Table
      headers={[
        'Clé',
        'Type de saisie',
        'Libellé',
        'Nb options',
        'Sigle Sacha',
        <div
          key="actions-header"
          className={clsx('d-flex-align-center')}
          style={{ justifyContent: 'space-between' }}
        >
          <span>Actions</span>
          {!readOnly && (
            <Button
              size="small"
              iconId="fr-icon-add-line"
              onClick={onAdd}
              title="Ajouter un descripteur"
            />
          )}
        </div>
      ]}
      data={fields.map((field) => {
        return [
          field.key,
          FieldInputTypeLabels[field.inputType],
          field.label,
          field.options.length > 0 ? String(field.options.length) : '–',
          field.sachaCommemoratifSigle ?? '–',
          <div
            key={field.id}
            className={cx('fr-btns-group', 'fr-btns-group--inline')}
          >
            {!readOnly && (
              <Button
                priority="tertiary no outline"
                iconId="fr-icon-delete-line"
                size="small"
                title="Supprimer"
                onClick={() => onDelete(field)}
              />
            )}
            <Button
              priority="tertiary no outline"
              iconId="fr-icon-arrow-right-line"
              size="small"
              title={readOnly ? 'Consulter' : 'Modifier'}
              onClick={() => onEdit(field)}
            />
          </div>
        ];
      })}
      fixed={true}
    />
  );
};
